import QAppLoader from 'components/qvrf_component/QAppLoader';
import JSQlikLoader from 'components/qvrf_component/JSQlikLoader';

const requireFiles = async (config, prefix) => {
    if (window && window.require) {
        window.require.config({
            baseUrl: `${
                (config.secure ? 'https://' : 'http://') +
                config.host +
                (config.port ? `:${config.port}` : '') +
                prefix
            }resources`,
            paths: {
                qlik: `${
                    (config.secure ? 'https://' : 'http://') +
                    config.host +
                    (config.port ? `:${config.port}` : '') +
                    prefix
                }resources/js/qlik`,
            },
            config: {
                text: {
                    useXhr() {
                        return true;
                    },
                },
            },
        });
    } else {
        throw new Error('window.require failed');
    }
};

export const openApp = async (config, qlik, prefix) => {
    try {
        const host = config.host.replace(/^https?:\/\//, '');
        return await qlik.openApp(config.appId, {
            ...config,
            isSecure: config.secure,
            prefix,
            host,
        });
    } catch (err) {
        throw new Error('openAPP failed');
    }
};

const applyTheme = (app) => {
    return new Promise((resolve, reject) => {
        app.theme
            .getApplied()
            .then((qTheme) => {
                if (qTheme.id !== 'AI Abacus') {
                    app.theme.get('AI Abacus').then((theme) => {
                        theme.apply();
                    });
                }
                resolve();
            })
            .catch((error) => {
                console.error('Failed to apply theme', error);
                reject('failed to apply theme');
            });
    });
};

export const fetchApp = async (config, prefix) => {
    const qlikService = new JSQlikLoader();
    const qlik = await qlikService.init();
    const app = await openApp(config, qlik, prefix).catch((err) => {
        console.error('Failed to open app', err);
    });

    await applyTheme(app);
    return app;
};

/**
 * Load the Qlik Sense App Promise, All API can be triggered from the qApp function eg qApp.getObject,
 * @param config
 * @param qTicket
 * @returns {Promise<void>}
 */
const qApp = async (config, qTicket) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (!config || !config.host || !config.prefix) {
                reject('config not set');
                throw new Error('Qlik config not found');
            }

            const qAppLoader = new QAppLoader(config, qTicket);
            await qAppLoader.init().catch((err) => {
                reject('loadCapabilityAPIs failed', err);
            });

            const prefix = config.prefix !== '' ? `/${config.prefix}/` : '/';

            await requireFiles(config, prefix).catch((err) => {
                throw new Error('require files failed');
            });

            const app = await fetchApp(config, prefix);
            resolve(app);
        } catch (error) {
            reject(error);
        }
    });
};

export default qApp;
